<template>
  <div>
    <div class="search col-lg-12 col-md-12">
      <table class="table table-hover">
        <thead>
        <tr>
          <th>Client</th>
          <th>Group</th>
          <th>Network</th>
          <th>Added</th>
          <th>Deployed</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row, i) in results" :key="'results-' + i">
          <td>{{ row.client.name }}</td>
          <td>{{ row.group ? row.group.name : row.client.name }}</td>
          <td>{{ row.all }}</td>
          <td>{{ row.added }}</td>
          <td>{{ row.moved }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      results: 'getBuildReport'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Overview/Report/List.vue